import { t } from "../services/utils";
export default {
  CLIENT_PROGRAM: 1,
  WORKOUT_TEMPLATE: 2,
  PUBLIC_WORKOUT: 3,
  PLAN_TEMPLATE: 4
};